import { createAsyncThunk } from '@reduxjs/toolkit'
import { BENEFIT_URLS } from '../../../../configs/api'
import { AxiosService } from '../../../../services/api'
import { createThunkName } from '../../../../utils/createThunkname'
import { CreateOrUpdateBenefitDto, GetAllBenefitsResponse } from './types'

const PREFIX = 'benefit'

export const BenefitService = {
  getBenefitsAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getBenefits'), async () => {
    try {
      const result = await AxiosService.get<GetAllBenefitsResponse>(BENEFIT_URLS.getAllBenefits)
      return result.data
    } catch (error) {
      throw error
    }
  }),
  createOrUpdateBenefitsAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'createOrUpdateBenefits'),
    async (dto: CreateOrUpdateBenefitDto) => {
      try {
        await AxiosService.post(BENEFIT_URLS.createOrUpdateBenefits, dto)
      } catch (error) {
        throw error
      }
    }
  )
}
